import React, { useRef, useEffect } from 'react'
import Slider from '@material-ui/lab/Slider'
import AvatarEditor from 'react-avatar-editor'
import Typography from '@material-ui/core/Typography'

function getCanvasStyle() {
  return {
    margin: `20px 30%`,
    maxWidth: `300px`,
  }
}
const CropImage = ({
  imageSrc,
  onCrop,
  setEditorRef,
  scaleValue,
  onScaleChange,
  handleClose,
}) => {
  const [modalStyle] = React.useState(getCanvasStyle)
  const ref = useRef(null)

  useEffect(() => {
    setEditorRef(ref)
  }, [ref])

  if (!imageSrc) return null

  return (
    <div style={modalStyle}>
      <AvatarEditor
        ref={ref}
        image={imageSrc}
        scale={scaleValue}
        width={200}
        height={200}
        border={20}
        borderRadius={200}
        color={[250, 250, 250, 0.9]} // RGBA
        rotate={0}
      />

      <Typography id="discrete-slider" gutterBottom>
        zoom
      </Typography>
      <input
        style={{ width: '100%', marginTop: '1rem' }}
        type="range"
        value={scaleValue}
        min="1"
        max="10"
        onChange={onScaleChange}
      />
      <button
        style={{
          marginTop: '1rem',
          cursor: 'pointer',
          border: '1px solid rgba(0, 161, 228, 0.5)',
          backgroundColor: '#FFFFFF',
          color: '#00A1E4',
          padding: '5px 16px',
          borderRadius: 20,
          left: '75%',
          textAlign: 'center',
        }}
        onClick={onCrop}
      >
        Save
      </button>
      <button
        style={{
          marginLeft: '30%',
          cursor: 'pointer',
          border: '1px solid rgba(0, 161, 228, 0.5)',
          backgroundColor: '#FFFFFF',
          color: '#00A1E4',
          padding: '5px 16px',
          borderRadius: 20,
        }}
        onClick={handleClose}
      >
        cancel
      </button>
    </div>
  )
}
export default CropImage



// WEBPACK FOOTER //
// ./src/components/crop/CropImage.js